import { useEffect } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";

const ConfirmDialog = ({ content, onOk = () => {}, onCancel = () => {} }) => {
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    modal.confirm({
      centered: true,
      title: "Confirm",
      icon: <ExclamationCircleOutlined />,
      content,
      okText: "Okay",
      cancelText: "Cancel",
      onOk: onOk,
      onCancel: onCancel,
    });
  }, []);

  return <>{contextHolder}</>;
};
export default ConfirmDialog;
